import { render } from "./InviteMembersDashboard.vue?vue&type=template&id=ee08cb32&scoped=true&ts=true"
import script from "./InviteMembersDashboard.vue?vue&type=script&lang=ts"
export * from "./InviteMembersDashboard.vue?vue&type=script&lang=ts"

import "./InviteMembersDashboard.vue?vue&type=style&index=0&id=ee08cb32&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee08cb32"]])

export default __exports__